// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cookie a{transition-property:background-color,border-color,color,fill,stroke;transition-duration:.3s;text-decoration:underline}#cookie a:hover{--text-opacity:1;color:#009d7f;color:rgba(0,157,127,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
